<template>
  <div class="user-legend">
    <div
      v-for="user in usersModified"
      v-ifield-b-tooltip.hover="{
        title: $t('appAnalyzeLegendUser.tooltip.title'),
        placement: 'bottom',
        delay: { show: 500, hide: 0 },
      }"
      v-bind:key="user.id"
    >
      <div
        class="user-legend-item"
        v-bind:class="{ disabled: !user.visible }"
        v-bind:style="{ '--color': user.hexColor }"
        v-on:click="$_onClickUser(user.id)"
        v-on:mouseenter="$_onHoverUser(user.id)"
        v-on:mouseleave="$_onHoverUser(null)"
      >
        {{ user.name }}
      </div>
    </div>
  </div>
</template>

<script>
import ColorUtil from '@/js/util/ColorUtil.js'

const getVisibleByKey = (visible, key) => {
  return typeof visible === 'boolean' ? visible : visible[key]
}

export default {
  name: 'AppAnalyzeLegendUser',
  props: {
    users: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: [Object, Boolean],
      default: true,
    },
  },
  computed: {
    usersModified: function () {
      return this.users.map((u) => ({
        ...u,
        hexColor: ColorUtil.rgbToHex(u.color),
        visible: getVisibleByKey(this.visible, `${u.id}`),
      }))
    },
  },
  methods: {
    $_onClickUser: function (id) {
      const visible = Object.fromEntries(
        this.usersModified.map((u) => [u.id, u.visible])
      )
      visible[`${id}`] = !visible[`${id}`]
      this.$emit('user-visible-changed', visible)
    },
    /**
     * ホバーイベント処理。
     * @param {Number} id ユーザーID
     */
    $_onHoverUser: function (id) {
      /**
       * ユーザーホバー状態変更イベント
       * @param {Number} id ユーザーID
       */
      this.$emit('user-hover-changed', id)
    },
  },
}
</script>

<style lang="scss" scoped>
$-indicator-size: 14px;

.user-legend {
  width: 100%;
  row-gap: 16px;
  column-gap: 40px;
  display: grid;
  $-fit-length: calc(50% - 16px);
  grid-template-columns: fit-content($-fit-length) fit-content($-fit-length);
  justify-content: center;
}

.user-legend-item {
  --color: $entity-color-black;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  column-gap: 16px;
  text-align: left;
  user-select: none;
  &::before {
    content: '';
    flex-shrink: 0;
    flex-grow: 0;
    width: $-indicator-size;
    height: $-indicator-size;
    border-radius: 50%;
    background-color: var(--color);
  }
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
  &.disabled {
    color: #cfcfcf;
    &::before {
      background-color: #cfcfcf;
    }
  }
}
</style>
